// extracted by mini-css-extract-plugin
export default {"header":"Table_header__MgIzf","link":"Table_link__UbDBX","active":"Table_active__N6Bue","inactive":"Table_inactive__pVG62"};